import React from 'react'
import { useQuery } from '@apollo/client'
import { Container, Header, Grid } from 'semantic-ui-react'
import { LOAD_USER_QUERY } from '../../graphql/user'
import ExpertStatus from './ExpertStatus'
import ExpertProjects from './ExpertProjects'
import ExpertTags from './ExpertTags'
import ExpertExpertise from './ExpertExpertise'
import LoadingSpinner from '../LoadingSpinner'
import './styles.css'

const ExpertDetail = ({ userId, onSelect, selectedExperts }) => {
    const { loading, data } = useQuery(LOAD_USER_QUERY, {
        variables: {
            id: userId,
        },
        skip: !userId,
    })

    if (loading) return <LoadingSpinner />

    if (!data) return <div></div>

    return (
        <Container className="sidebar-container">
            <Header size="huge" textAlign="center">
                <Header.Content>
                    {data.user.fullName || data.user.email}
                    <Header.Subheader>
                        {`${data.user.expert.title} | ${data.user.expert.organization.name}`}
                    </Header.Subheader>
                </Header.Content>
            </Header>
            <Grid className="expert-info">
                <ExpertStatus
                    expert={data.user}
                    onSelect={onSelect}
                    selectedExperts={selectedExperts}
                />
                <ExpertExpertise expert={data.user} />
                <ExpertProjects expert={data.user} />
                <ExpertTags expert={data.user} />
            </Grid>
        </Container>
    )
}

export default ExpertDetail
